<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col class="align-center" cols="12">
        <v-img style="margin: auto auto;" aspect-ratio="3" max-width="287px" alt="logo-sesi" src="../assets/sesi-logo.png"></v-img>
      </v-col>
      <v-col cols="12" xs="12" sm="8" md="6" lg="4">
        <v-card class="ma-3 pa-6">
          <v-card-title>Acesso ao sistema</v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field v-model="email" label="E-mail"></v-text-field>
              <v-text-field @keyup.enter="login()" v-model="senha" label="Senha" type="password"></v-text-field>
              <br />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loginLoading" @click="login()" color="primary" block x-large dark>
              <v-icon left>mdi mdi-login</v-icon>Logar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
  </v-container>
</template>

<script>
// @ is an alias to /src
import AlertSystem from "../components/AlertSystem.vue";
export default {
  name: "Home",
  components: {
    AlertSystem,
  },
  data: () => ({
    system: {
      snackbar: {},
    },
    loginLoading: false,
    email: "",
    senha: "",
  }),
  methods: {
    login() {
      this.loginLoading = true;
      this.axios
        .post("auth/login", {
          email: this.email,
          password: this.senha,
        })
        .then((res) => {
          localStorage.setItem("access_token", res.data.access_token);
          sessionStorage.setItem("IdProfissional", JSON.stringify(res.data.IdProfissional))
          this.$store.commit('setAccessToken', res.data.access_token)
          location.href = "/dashboard"
        })
        .catch((e) => {

          if(e.response.status === 401){
            this.system.snackbar = {
              snackbar: true,
              text: e.response.data,
              color: "red",
            };
          }else{
            this.system.snackbar = {
              snackbar: true,
              text: e.response.status == 400 ? `${e.response.data.email}  ${e.response.data.password}` : e.response.data.message,
              color: "red",
            };
          }
        })
        .finally(() => {
            this.loginLoading = false;
        });
    },
  },
};
</script>
